module.exports = __webpack_public_path__ + "img/youye1.gif";